import React from 'react';
import { string } from '../../../localization';
import * as Constants from '../../../utilities/constants/Constants';
import './ScaleTool.scss';

export const ScaleTool = props => {
  const { scalarModalValue, initialValue, setScaleValue } = props;
  return (
    <div className='undraggable custom-input-section' id='scalar-tool'>
      {initialValue < 0 ? (
        <label
          htmlFor='formControlRange'
          className='scale-info'
          style={{ color: 'red' }}
        >
          {string.MINIMUM_ZOOM_WARNING}
        </label>
      ) : (
        <label htmlFor='formControlRange' className='scale-info'>
          {string.SCALE_INFO_STRING_KEY}
        </label>
      )}

      <div className='mt-2 form-group d-flex align-items-center'>
        {Constants.SLIDER_MIN_VALUE}
        <input
          type='range'
          className='form-control-range scale-slider'
          min={Constants.SLIDER_MIN_VALUE}
          max={Constants.SLIDER_MAX_VALUE}
          step='any'
          value={scalarModalValue}
          onChange={e => {
            setScaleValue(e, 'slider');
          }}
          id='formControlRange'
        />
        {Constants.SLIDER_MAX_VALUE}
      </div>

      <div className='d-flex justify-content-center align-items-center custom-input-box'>
        {string.ADJUST_SIZE_KEY}
        <input
          className='form-control ml-1 mr-1'
          type='number'
          onChange={e => {
            setScaleValue(e, 'manual');
          }}
          onKeyPress={e => {
            if (e.key === 'Enter' || e.key === 'Tab') {
              setScaleValue(e, 'manual');
            }
          }}
          value={initialValue}
        />
        %
      </div>
    </div>
  );
};
